import React from "react";
import {
  X,
  Mail,
  Calendar,
  User,
  Send,
  FileText,
  CheckCircle,
} from "lucide-react";
import moment from "moment";

const MailDetailPopup = ({ onClose, mailData }) => {
  // Extra Fields
  const status = "Sent";
  const sentBy = "Humza Samiullah";

  // Format body for UI. Records written by the backend `logEmail` helper
  // (open-house + custom transaction emails) carry no `body`, so guard it —
  // an undefined body must never crash the whole app.
  const bodyLines = String(mailData?.body || "")
    .split("\n")
    .filter((line) => line.trim());

  return (
    <>
      <div
        className="fixed inset-0 bg-black/50 z-40 transition-opacity"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center ">
        <div className=" rounded-lg  overflow-hidden shadow-2xl w-[90%] lg:w-[50%] h-[85%]  bg-white">
          {/* Header */}
          <div className="bg-[#1E293B] text-white px-8 py-4 flex justify-between items-center">
            <div>
              <h2 className="text-xl md:text-2xl font-bold">Email Details</h2>
              <p className="text-sm opacity-80 mt-1 flex items-center gap-2">
                <Calendar size={16} />
                {moment(mailData.id).format("MM/DD/YYYY")}
              </p>
            </div>

            <button
              onClick={onClose}
              className="hover:rotate-90 transition duration-300"
            >
              <X size={20} />
            </button>
          </div>

          {/* Body */}
          <div className="p-8 max-h-[85vh] overflow-y-auto">
            {/* Top Info Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-8">
              <div className="bg-gray-50 border rounded-2xl px-5 py-3">
                <p className="text-sm text-gray-500">Status</p>
                <p className="font-semibold text-green-600 flex items-center gap-2">
                  <CheckCircle size={18} />
                  {status}
                </p>
              </div>

              <div className="bg-gray-50 border rounded-2xl px-5 py-3">
                <p className="text-sm text-gray-500">Type</p>
                <p
                  className={`font-semibold ${mailData.type === "staging" ? " text-linkColor" : " text-red-600"} capitalize`}
                >
                  {mailData.type}
                </p>
              </div>

              <div className="bg-gray-50 border rounded-2xl px-5 py-3 flex flex-col justify-center">
                <p className="text-sm text-gray-500">To</p>
                <p className="font-semibold">{mailData.receivername}</p>
                <p className="text-sm text-gray-600">{mailData.to}</p>
              </div>

              <div className="bg-gray-50 border rounded-2xl px-5 py-3 flex flex-col justify-center">
                <p className="text-sm text-gray-500">Sent By</p>
                <p className="font-medium">{sentBy}</p>
              </div>

              <div className="bg-gray-50 border rounded-2xl px-5 py-3 md:col-span-2">
                <p className="text-sm text-gray-500">Subject</p>
                <p className="font-medium text-base leading-relaxed">
                  {mailData.subject}
                </p>
              </div>
            </div>

            {/* Email Body */}
            <div className="bg-slate-50 border rounded-3xl px-5 py-3 mb-20">
              <div className="text-xl font-bold mb-3 flex items-center gap-2 text-slate-800">
                <Mail className="text-[#1E293B] mt-1" size={18} />
                <span>Email Body</span>
              </div>

              <div className="space-y-4 text-gray-700 leading-3 text-sm">
                {bodyLines.map((line, index) => {
                  if (line.includes("Here are the details:")) {
                    return (
                      <div key={index} className="font-bold text-lg">
                        {line}
                      </div>
                    );
                  }
                  if (line.includes("Lockbox Info:")) {
                    return (
                      <div key={index} className="font-bold">
                        {line}
                      </div>
                    );
                  }
                  // Highlight sections
                  if (line.includes("Address:")) {
                    return (
                      <div key={index} className="font-bold">
                        {line}
                      </div>
                    );
                  }

                  if (
                    line.includes("Client 1:") ||
                    line.includes("Client 2:") ||         line.includes("Client 3:") ||         line.includes("Client 4:") ||         line.includes("Client 5:") ||         line.includes("Closing Date:")
                  ) {
                    return (
                      <div
                        key={index}
                        className="text-[#1E293B] font-bold"
                      >
                        {line}
                      </div>
                    );
                  }

                  return (
                    <p key={index} className="whitespace-pre-line">
                      {line}
                    </p>
                  );
                })}
              </div>
            </div>

            {/* Footer Buttons */}
            {/* <div className="flex justify-end gap-4 mt-8">
              <button
                onClick={onClose}
                className="px-6 py-3 rounded-xl border border-gray-300 hover:bg-gray-100 transition"
              >
                Close
              </button>

              <button className="px-6 py-3 rounded-xl bg-themeColor text-white hover:bg-themeColor/90 transition shadow-lg flex items-center gap-2">
                <Send size={18} />
                Reply
              </button>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default MailDetailPopup;
